const validUrlRegExp = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/;
export const isValidUrl = (value) => validUrlRegExp.test(value);
//# sourceMappingURL=url.js.map